import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { MarketingVendorSettings } from './marketing-vendor-settings.js';
import { MarketingVendorType } from './marketing-vendor-type.js';

export class PersistenceOnlySettings extends MarketingVendorSettings {
  static readonly TYPE_ID: string = 'a2fedb527ac9467d8f3802171527c092';

  private constructor() {
    super();
  }

  get $typeId(): string {
    return PersistenceOnlySettings.TYPE_ID;
  }

  get type(): MarketingVendorType {
    return MarketingVendorType.PersistenceOnly;
  }

  static create(): PersistenceOnlySettings {
    return new PersistenceOnlySettings();
  }

  static fromMap(context: SerializationContext, map: SerializedData): PersistenceOnlySettings {
    return this.create();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      type: fromEnumAsString(this.type),
    };
  }

  clone(): this {
    return PersistenceOnlySettings.create() as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return true;
  }
}

export class PersistenceOnlySettingsBuilder extends DataModelBuilder<PersistenceOnlySettings> {
  build(context: SerializationContext, map: SerializedData): PersistenceOnlySettings {
    return PersistenceOnlySettings.fromMap(context, map);
  }
}
